(() => {
  const popup = document.getElementById('TimedPromoPopup');
  const dismissedKey = 'irollingTimedPromoPopupDismissed';
  if (!popup || sessionStorage.getItem(dismissedKey)) return;

  const panel = popup.querySelector('.timed-promo-popup__panel');
  let opened = false;
  const close = () => {
    if (!opened) return;
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('timed-promo-popup-open');
    sessionStorage.setItem(dismissedKey, 'true');
  };
  const open = () => {
    opened = true;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('timed-promo-popup-open');
    panel.focus();
  };

  popup.querySelectorAll('[data-popup-close], [data-popup-action]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !popup.hidden) close(); });
  window.setTimeout(open, 10000);
})();
